
import type { ApiError } from '@empathyco/playboard-core-domain'
import type { AuthMessages } from '../../models/i18n/auth.messages'
import { defineComponent } from 'vue'
import { mapActions } from 'vuex'
import { DeviceEnum } from '../../enums/device.enum'
import { AUTH_CONSTS } from '../../store/auth/auth.consts'
import { UiCheckbox } from '../keen-ui'
import { EpbButton } from '../shared/epb-button'
import LoginError from './login-error.component.vue'
import LoginInput from './login-input.component.vue'

export default defineComponent({
  name: 'LoginForm',
  components: {
    EpbButton,
    LoginInput,
    UiCheckbox,
    LoginError,
  },
  props: {
    defaultKeepLoggedIn: Boolean,
    resetPasswordUrl: String,
  },
  data() {
    return {
      DeviceEnum,
      credentials: {
        username: undefined,
        password: undefined,
      },
      keepLoggedIn: false,
      loading: false,
      errorMessage: undefined,
    }
  },
  computed: {
    messages(): AuthMessages {
      return this.$epb.messages.auth
    },
  },
  methods: {
    ...mapActions(AUTH_CONSTS.moduleName, {
      login: AUTH_CONSTS.actions.login,
    }),
    onFormSubmit(event: Event): void {
      event.preventDefault()

      this.loading = true
      this.login({
        credentials: this.credentials,
        keepLoggedIn: this.keepLoggedIn,
      })
        .then(() => {
          this.loading = false
          this.errorMessage = undefined
          this.$emit('login', true)
        })
        .catch((error: ApiError) => {
          this.loading = false
          const errorMessages = this.messages.errors
          this.errorMessage =
            error.status === 401 ? errorMessages.invalidCredentials : errorMessages.default
          this.$emit('login', false)
        })
    },
  },
  watch: {
    'credentials.username': function (username: string): void {
      this.credentials.username = username.toLowerCase()
    },
  },
  created(): void {
    this.keepLoggedIn = this.defaultKeepLoggedIn
  },
})
